import React, { Component } from 'react';
import styles from './Solution.module.css';

import Zoom from 'react-reveal/Zoom';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';

import { Link } from 'react-router-dom';

import logo from '../../images/CVE_logo_shadow.svg';
import impactImg from '../../images/solution.jpg';
import playIcon from '../../images/play.svg';

import factImg1 from '../../images/boat.png';
import factImg2 from '../../images/plastic.png';
import factImg3 from '../../images/ponds.png';
import fishesImg from '../../images/fishes.png';
import mapImg from '../../images/map.png';
import footerImg1 from '../../images/footer-image1.png';
import footerImg2 from '../../images/footer-image2.png';
import footerImg3 from '../../images/footer-image3.png';


import Menu from '../../containers/Menu/Menu';
import IntroSection from '../../components/IntroSection/IntroSection';
import ImgSection from '../../components/ImgSection/ImgSection';

export default class Solution extends Component {
  render() {
    return (
      <div className={styles.Solution}>
        <Menu strokeColor="#000" />
        <div className={styles.nav}>
          <div className={styles.left}>
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className={styles.right}>
            {/* <div>
              {
                [...Array(4)].map((_, index) => {
                  if (index === (indicator - 1)) {
                    return <div key={index} style={{ width: '15px', transition: 'width 0.1s ease-out' }} />
                  } else {
                    return <div key={index} />
                  }
                })
              }
            </div> */}
          </div>
        </div>
        <IntroSection heading="Our global presence" textImg={impactImg} fontSize="100px" description="We promise a brighter future for Quality Seafood, for Us and for the Planet." />
        <section className={styles.factSection}>
          <div className={styles.top}>
            <div className={styles.topLeft}>
                <h2>Lorem Ipsum Dolor</h2>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor</p>
            </div>
            <Zoom>
              <div className={styles.factCircle}>
                <h4>Facts</h4>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor</p>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
              </div>
            </Zoom>
          </div>
          <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
          <div className={styles.bottom}>
            <Zoom top cascade>
            <div>
              <img src={factImg1} alt="" />
              <img src={playIcon} alt="" />
            </div>
            <div>
              <img src={factImg2} alt="" />
              <img src={playIcon} alt="" />
            </div>
            <div>
              <img src={factImg3} alt="" />
              <img src={playIcon} alt="" />
            </div>
            </Zoom>
          </div>
        </section>
        <ImgSection title="OUR MISSION" heading="Lorem Ipsum" image={fishesImg} />
        <ImgSection right title="OUR VISION" heading="Lorem &amp; conseturia" image={fishesImg} />
        <section className={styles.commitment}>
          <div>
            <h1>OUR COMMITMENT</h1>
            <h2>Lorem &amp; conseturia</h2>
            <p className={styles.lead}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor</p>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam</p>
          </div>
          <div>
            <Slide right>
            <p>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. <br /> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
            </p>
            </Slide>
          </div>
        </section>
        <section className={styles.presence}>
          <Fade bottom cascade>
          <h2>Our Global Presence</h2>
          <p className={styles.lead}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
          </p>
          <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd</p>
          </Fade>
          <Zoom>
          <img src={mapImg} alt="coverage" />
          </Zoom>
        </section>
        <section className={styles.footer}>
          <div className={styles.top}>
            <Slide bottom><h2>Lorem Facility</h2></Slide>
            <Slide bottom><p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet</p></Slide>
          </div>
          <div className={styles.middle}>
            <Fade bottom cascade delay={300}>
              <img src={footerImg1} alt="" />
              <img src={footerImg2} alt="" />
              <img src={footerImg3} alt="" />
            </Fade>
          </div>
          <div className={styles.bottom}>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore</p>
            <Link to="/contact">CONTACT US</Link>
          </div>
        </section>
      </div>
    )
  }
}
